export default __webpack_public_path__ + "static/media/Japan_Particle_0008_Yamato_Firework2.91d99be9.png";